<div class="col-12 d-flex justify-content-around mt-2 dirI flex-wrap" [formGroup]="inputModel">
    <div class="col-12 d-flex flex-wrap justify-content-around">
        <div class="col-md-3 col-11  dirI">
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="strDate" class="form-control shadow text-end" readonly />
            </ng-persian-datepicker>
        </div>

        <div class="col-md-3 col-11 mt-2 mt-md-0  dirI">
            <div class="input-group clockpicker">
                <input type="text" class="form-control shadow bg-light" readonly formControlName="strTime" id="time">
                <span class="input-group-addon ">
                <span class="glyphicon glyphicon-time"></span>
                </span>
            </div>
        </div>
        <div class="col-md-3 col-12 mt-2 mt-md-0  dirI d-flex justify-content-around">
            <button class="btn btn-primary" (click)="search()">جستجو</button>
            <a class="btn btn-warning" href="/mapInput" target="_blank">نمایش بر روی نقشه</a>
        </div>
    </div>
    <div class="col-12 d-flex flex-wrap justify-content-around mt-2">
        <div class="col-md-3 col-11  dirI">
            <label>حوزه خدمت</label>
            <select class="form-select" id="domainDashbord" (change)="changeDomain($event.target)">
            <option value="-1">انتخاب کنید</option>
            <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
        </select>
        </div>
        <div class="col-md-3 col-11  dirI">
            <label>کاربری ورودی</label>
            <select class="form-select" (change)="changeTypeData($event.target)">
          <option value="-1">انتخاب کنید</option>
            <option *ngFor="let item of IOUsage" value="{{item.iIOUsage}}">{{item.strComment}}</option>
        </select>
        </div>
        <div class="col-md-3 col-11 mt-2 mt-md-0 col-md-3 dirI d-flex flex-wrap justify-content-between">
            <div>
                <i class="fa fa-file-excel-o text-success fa-2x pointer" (click)="exportexcel('liveInput')" title="خروجی اکسل"></i>
            </div>
            <div class="d-flex flex-row align-items-center">
                <label for="show-last-th">نمایش آخرین ستون</label>
                <input type="checkbox" class="form-check" id="show-last-th" checked>
            </div>

        </div>
    </div>

</div>
<hr class="w-100">
<div style="height: 80vh; overflow-y: auto;" id="scroll-handel">
    <table class="table mt-1 dirI table-striped f12" id="liveInput">
        <thead class=" dirI ">
            <tr class="text-center ">
                <th scope="col " class=""># </th>
                <th scope="col" class="">موقعیت</th>
                <th scope="col" class="">تاریخ </th>
                <th scope="col" class="">ساعت </th>
                <th scope="col" class="">نوع ورودی </th>
                <th scope="col" class="">وضعیت </th>

                <th scope="col" class="">مقدار </th>
                <th scope="col" class="">نام راننده</th>
                <th scope="col" class="">موبایل راننده </th>
                <th scope="col" class="">پلاک </th>
                <th scope="col" class="">حوزه خدمت </th>
                <th scope="col" class="">نوع خودرو </th>
                <th scope="col" class="">گروه خودرو </th>


                <th class="d-none" scope="col">عرض جغرافیایی</th>
                <th class="d-none" scope="col">طول جغرافیایی</th>

                <th class="d-none" scope="col">کاربری </th>
                <th class="d-none" scope="col">سرعت مجاز </th>

            </tr>
        </thead>
        <tbody>
            <tr class="text-center  dirI " *ngFor="let item of inputsData;let i=index" [style.background-color]="item.strValue=='0' ? '#efa5a0' : (item.strValue=='1' ? '#aafa9f' : null)">
                <th class="">{{i+1|faNum}}</th>

                <th class="" data-bs-toggle="modal" data-bs-target="#map" (click)="openMap(item.fLat,item.fLon,item.strDate+'-'+item.strTime,item.strIOUsage_strComment)"><i class="fa fa-map-marker mx-2 pointer"></i></th>
                <th class="">{{item.strDate|faNum}}</th>
                <th class="">{{item.strTime|faNum}}</th>
                <th class="">{{item.strIOUsage_strComment}}</th>
                <th class="txt-navy bold">{{item.strValueTitle|faNum}}</th>

                <th class="text-black bold">{{item.strValue|faNum}}</th>
                <th class="">{{item.strFullName}}</th>
                <th class="">{{item.strMobile|faNum}}</th>
                <th class="">{{item.strVehicleNo}}</th>
                <th class="">{{item.strMobileDomain_strComment}}</th>
                <th class="">{{item.strMobileGroup_strComment}}</th>
                <th class="">{{item.strMobileType_strComment}}</th>

                <td class="d-none">{{item.fLat}}</td>
                <td class="d-none">{{item.fLon}}</td>
                <td class="d-none">{{item.strMobileType_strComment}}</td>

                <td class="d-none">{{item.tiMaxSpeed}}</td>
            </tr>

        </tbody>
    </table>
</div>


<!--Modal-->
<div class="modal" id="map" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="">نقشه</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div id="map-modal" class="position-sticky w-100" style="height: 400px;">
                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>